<template>
    <div>
        <div class="d-flex flex-row" style="">
            <div class="flex-col mr-auto">
                <h4>{{ day.name }}</h4>
            </div>

            <div class="flex-col">
                <div class="btn-group">
                  <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Edit
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" type="button" @click="startUpdateMacros">Edit target macros</button>
                    <button class="dropdown-item" type="button" @click="resetDayMacroTargets">Auto-set target macros</button>
                    <button class="dropdown-item" type="button" @click="regenerateMeals">Auto-pick all meals</button>
                  </div>
                </div>
            </div>
        </div>

        <div class="mb-1">
            <div class="alert border-danger alert-danger w-100" v-if="mealsPerDayDoesntMatch">
                This day has {{ this.day.meals.length }} out of {{ this.$root.plan.data.desired_meals_per_day }} desired meals per day <br>
                <button class="btn btn-sm btn-secondary" type="button" @click="resetMealMacroTargets">Reset meals</button>
                <button class="btn btn-sm btn-secondary" type="button" @click="resetMealMacroTargetsAndRegenerate">Reset meals and auto-pick meals</button>
            </div>
            <div class="alert border-warning alert-warning w-100" v-if="intakeUpdatedSinceLastUpdated">
                Intake has been updated since plan last generated!<br>
<!--                 Form: {{ intakeFormUpdatedAt | moment("M/DD/YYYY hh:mm a") }}<br>
                This Day: {{ day.updated_at | moment("M/DD/YYYY hh:mm a") }} -->
                <button class="btn btn-sm btn-secondary" type="button" @click="resetDayMacroTargets">Auto-set day macro targets</button>
            </div>
            <div class="card border-danger mb-3 w-100" style="" v-if="!dayTargetAndMealTargetSumAreTheSame">
                <div class="card-header text-white bg-danger">Day and Meal macro targets do not match:</div>
                <div class="card-body">
                    <!-- <h5 class="card-title text-danger">Day and Meal macro targets do not match:</h5> -->
                    <table class="table table-sm table-bordered">
                        <thead class="">
                            <tr>
                                <th scope="col">Total</th>
                                <th scope="col">Cals</th>
                                <th scope="col">Prot (g)</th>
                                <th scope="col">Carbs (g)</th>
                                <th scope="col">Fat (g)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">Day target:</th>
                                <td class="text-right">{{ day.target_calories | toFixed(0) }}</td>
                                <td class="text-right">{{ day.target_protein_g | toFixed(0) }}</td>
                                <td class="text-right">{{ day.target_carbohydrate_g | toFixed(0) }}</td>
                                <td class="text-right">{{ day.target_fat_g | toFixed(0) }}</td>
                            </tr>
                            <tr>
                                <th scope="row">Meals target:</th>
                                <td class="text-right">{{ sumMealsTargetCalories | toFixed(0) }}</td>
                                <td class="text-right">{{ sumMealsTargetProtein | toFixed(0) }}</td>
                                <td class="text-right">{{ sumMealsTargetCarbohydrate | toFixed(0) }}</td>
                                <td class="text-right">{{ sumMealsTargetFat | toFixed(0) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <button class="btn btn-sm btn-secondary" @click="updateDayTargetsWithMealTargets">Update day targets</button>
                    <button class="btn btn-sm btn-secondary" @click="resetMealMacroTargets">Auto-set meal targets</button>
                </div>
            </div>
            <table class="table table-sm table-bordered">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">Total</th>
                        <th scope="col">Cals</th>
                        <th scope="col">Prot (g)</th>
                        <th scope="col">Carbs (g)</th>
                        <th scope="col">Fat (g)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Day target:</th>
                        <td class="text-right">{{ day.target_calories | toFixed(0) }}</td>
                        <td class="text-right">{{ day.target_protein_g | toFixed(0) }} <small>({{ proteinGramsToCalories(day.target_protein_g)/day.target_calories*100 | toFixed(1) }}%)</small></td>
                        <td class="text-right">{{ day.target_carbohydrate_g | toFixed(0) }} <small>({{ carbohydrateGramsToCalories(day.target_carbohydrate_g)/day.target_calories*100 | toFixed(1) }}%)</small></td>
                        <td class="text-right">{{ day.target_fat_g | toFixed(0) }} <small>({{ fatGramsToCalories(day.target_fat_g)/day.target_calories*100 | toFixed(1) }}%)</small></td>
                    </tr>
                    <tr>
                        <th scope="row">Actual:</th>
                        <td class="text-right" v-bind:class="within5pctClass(day.calories,day.target_calories)">{{ day.calories | toFixed(0) }}</td>
                        <td class="text-right" v-bind:class="within5pctClass(day.protein_g,day.target_protein_g)">{{ day.protein_g | toFixed(0) }} <small>({{ proteinGramsToCalories(day.protein_g)/day.calories*100 | toFixed(1) }}%)</small></td>
                        <td class="text-right" v-bind:class="within5pctClass(day.carbohydrate_g,day.target_carbohydrate_g)">{{ day.carbohydrate_g | toFixed(0) }} <small>({{ carbohydrateGramsToCalories(day.carbohydrate_g)/day.calories*100 | toFixed(1) }}%)</small></td>
                        <td class="text-right" v-bind:class="within5pctClass(day.fat_g,day.target_fat_g)">{{ day.fat_g | toFixed(0) }} <small>({{ fatGramsToCalories(day.fat_g)/day.calories*100 | toFixed(1) }}%)</small></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-for="(meal, index) in day.meals" v-bind:key="index">
            <!-- <div>{{ index }}: Target calories: {{ meal.target_calories }}</div> -->
            <div class="alert alert-secondary text-center" v-if="index+1 == day.training_index">
                Training
            </div>
            <meal-component :initial-meal="meal" :index="index" @meal-updated="onMealUpdated">
            </meal-component>
        </div>
        <modal v-if="showUpdateMacrosModal" @close="showUpdateMacrosModal=false">
            <h3 slot="header">Update targets for {{ day.name }}</h3>
            <div slot="body">
                <table class="table table-sm table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th></th>
                            <th>Original</th>
                            <th>New</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Calories</td>
                            <td>{{ day.target_calories | toFixed(2)}}</td>
                            <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Total Calories" required v-model="updatedMacros.calories" @keyup="updateTargetCalories"></td>
                        </tr>
                        <tr>
                            <td>Protein (g)</td>
                            <td>{{ day.target_protein_g | toFixed(2)}}</td>
                            <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Protein in grams" required v-model="updatedMacros.protein" @keyup="updateTargetProtein"></td>
                        </tr>
                        <tr>
                            <td>Carbohydrate (g)</td>
                            <td>{{ day.target_carbohydrate_g | toFixed(2)}}</td>
                            <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Carbs in grams" required v-model="updatedMacros.carbohydrate" @keyup="updateTargetCarbohydrate"></td>
                        </tr>
                        <tr>
                            <td>Fat (g)</td>
                            <td>{{ day.target_fat_g | toFixed(2)}}</td>
                            <td><input type="number" style="width:120px;" step="1" class="form-control" placeholder="Fat in grams" required v-model="updatedMacros.fat" @keyup="updateTargetFat"></td>
                        </tr>
                    </tbody>
                </table>
                <div class="">
    <!--                   <div class="form-group">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="regenerate-meal-toggle" v-model="updatedMacros.regenerateMeal">
                          <label class="form-check-label" for="regenerate-meal-toggle">
                            Regenerate meal
                          </label>
                        </div>
                      </div> -->
                    <button @click="updateMacros()" class="btn btn-primary">Update</button>
                    <button @click="resetUpdatedMacros()" class="btn btn-secondary">Reset</button>
                </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showUpdateMacrosModal = false">
                Cancel
              </button>
            </div>
        </modal>
    </div>
</template>
<script>
  export default {
    props: [
        'initialDay'
    ],
    data() {
        return {
            day: this.initialDay,
            showUpdateMacrosModal: false,
            updatedMacros: {
                'calories': this.initialDay.target_calories,
                'protein': this.initialDay.target_protein_g,
                'carbohydrate': this.initialDay.target_carbohydrate_g,
                'fat': this.initialDay.target_fat_g,
                'regenerateMeal': false,
            }
        }
    },
    mounted() {
    },
    computed: {
        mealsPerDayDoesntMatch: function() {
            return this.day.meals.length != this.$root.plan.data.desired_meals_per_day;
        },
        intakeUpdatedSinceLastUpdated: function() {
            return this.day.updated_at < this.$root.plan.intake_updated_at;
        },
        sumMealsTargetCalories: function() {
            return this.day.meals.reduce(function(total, meal){
                return total + parseFloat(meal.target_calories);
            },0);
        },
        sumMealsTargetProtein: function() {
            return this.day.meals.reduce(function(total, meal){
                return total + parseFloat(meal.target_protein_g);
            },0);
        },
        sumMealsTargetCarbohydrate: function() {
            return this.day.meals.reduce(function(total, meal){
                return total + parseFloat(meal.target_carbohydrate_g);
            },0);
        },
        sumMealsTargetFat: function() {
            return this.day.meals.reduce(function(total, meal){
                return total + parseFloat(meal.target_fat_g);
            },0);
        },
        dayTargetAndMealTargetSumAreTheSame: function() {
            if (
                Math.round(this.day.target_calories) != this.sumMealsTargetCalories.toFixed(0)
                || Math.round(this.day.target_protein_g) != this.sumMealsTargetProtein.toFixed(0)
                || Math.round(this.day.target_carbohydrate_g) != this.sumMealsTargetCarbohydrate.toFixed(0)
                || Math.round(this.day.target_fat_g) != this.sumMealsTargetFat.toFixed(0)
            ) {
                return false;
            }
            return true;
        },
    },
    methods: {
        onMealUpdated: function(meal) {
            var _this = this;

            axios.get('/api/meal_plan_days/' + _this.day.id).then(function (response) {
                _this.day = response.data.data;
                _this.$emit('day-updated', _this.day);
            });
        },
        updateDayTargetsWithMealTargets: function() {
            var _this = this;

            axios.put('/api/meal_plan_days/' + _this.day.id, {
                target_calories: this.sumMealsTargetCalories,
                target_protein_g: this.sumMealsTargetProtein,
                target_carbohydrate_g: this.sumMealsTargetCarbohydrate,
                target_fat_g: this.sumMealsTargetFat,
            }).then(function (response) {
                _this.day = response.data.data;
                _this.$emit('day-updated');
            });
        },
        resetMealMacroTargets: function() {
            var _this = this;

            axios.put('/api/meal_plan_days/' + _this.day.id, {
                'reset_meal_macro_targets': true
            }).then(function (response) {
                // console.log(response.data.data);
                Vue.set(_this, 'day', response.data.data);
                // _this.onMealUpdated();
                // _this.day = response.data.data;
                _this.$emit('day-updated');
            });
        },
        resetDayMacroTargets: function() {
            var _this = this;

            axios.put('/api/meal_plan_days/' + _this.day.id, {
                'reset_macro_targets': true
            }).then(function (response) {
                // console.log(response.data.data);
                Vue.set(_this, 'day', response.data.data);
                // _this.onMealUpdated();
                // _this.day = response.data.data;
                _this.$emit('day-updated');
            });
        },
        resetMealMacroTargetsAndRegenerate: function() {
            var _this = this;
            axios.put('/api/meal_plan_days/' + _this.day.id, {
                'reset_meal_macro_targets': true,
                'regenerate_meals': true
            }).then(function (response) {
                // console.log(response.data.data);
                Vue.set(_this, 'day', response.data.data);
                // _this.onMealUpdated();
                // _this.day = response.data.data;
                _this.$emit('day-updated');
            });
        },
        setAllMealsLoading: function(bool) {
            $.each(this.day.meals, function(key, value) {
                Vue.set(value, 'isLoading', bool);
            });
        },
        regenerateMeals: function() {
            var _this = this;
            _this.setAllMealsLoading(true);

            axios.put('/api/meal_plan_days/' + _this.day.id, {
                'regenerate_meals' : true
            }).then(function (response) {
                // console.log(response.data.data);
                Vue.set(_this, 'day', response.data.data);
                // _this.onMealUpdated();
                // _this.day = response.data.data;
                _this.$emit('day-updated');
                _this.setAllMealsLoading(false);
            })
            .catch(e => {
                // this.errors.push(e)
                // console.log(e.response.data.message);
                _this.$toasted.error(e.response.data.message);
                _this.setAllMealsLoading(false);
            })
        },
        startUpdateMacros: function () {
            var _this = this;
            _this.showUpdateMacrosModal = true;
        },
        updateMacros: function () {
            var _this = this;
            // Vue.set(_this.meal, 'isLoading', true);
            axios.put('/api/meal_plan_days/' + this.day.id, {
                'target_calories': this.updatedMacros.calories,
                'target_protein_g': this.updatedMacros.protein,
                'target_carbohydrate_g': this.updatedMacros.carbohydrate,
                'target_fat_g': this.updatedMacros.fat,
                // 'update_similar_days': true
                // 'regenerate_meal': this.updatedMacros.regenerateMeal,
            }).then((response) => {
                // var data = response.data.data;
                _this.$emit('day-updated');
                Object.assign(_this.day, response.data.data);
                _this.showUpdateMacrosModal = false;
                // Vue.set(_this.meal, 'isLoading', false);
            });
        },
        resetUpdatedMacros: function () {
            this.updatedMacros = {
                'calories': this.initialDay.target_calories,
                'protein': this.initialDay.target_protein_g,
                'carbohydrate': this.initialDay.target_carbohydrate_g,
                'fat': this.initialDay.target_fat_g,
            };
        },
        within5pctClass: function within5pctClass(newVal, oldVal)
        {
            return this.$root.within5pctClass(newVal, oldVal);
        },
        updateTargetCalories: function () {
            // if calories changes, alter carbs.
            var protein_calories = parseFloat(this.updatedMacros.protein)*4;
            var fat_calories = parseFloat(this.updatedMacros.fat)*9;
            var calories = parseFloat(this.updatedMacros.calories);

            this.updatedMacros.carbohydrate = ((calories - protein_calories - fat_calories)/4).toFixed(2);
        },
        updateTargetProtein: function () {
            // if protein changes, alter carbs.
            this.updateTargetCalories();
        },
        updateTargetFat: function () {
            // if fat changes, alter carbs.
            this.updateTargetCalories();
        },
        updateTargetCarbohydrate: function () {
            // if carbohydrate changes, alter fat.
            var protein_calories = parseFloat(this.updatedMacros.protein)*4;
            var fat_calories = parseFloat(this.updatedMacros.fat)*9;
            var carbohydrate_calories = parseFloat(this.updatedMacros.carbohydrate)*4;
            var calories = parseFloat(this.updatedMacros.calories);

            this.updatedMacros.fat = ((calories - protein_calories - carbohydrate_calories)/9).toFixed(2);
        },
        proteinGramsToCalories: function (protein_g) {
            return protein_g*4;
        },
        carbohydrateGramsToCalories: function (carbohydrate_g) {
            return carbohydrate_g*4;
        },
        fatGramsToCalories: function (fat_g) {
            return fat_g*9;
        }
    },
    watch: {
        initialDay: function (newVal,oldVal) {
            Vue.set(this, 'day', newVal);
        }
    }
}
</script>
